"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var menu_item_1 = require("../../models/menu-item");
var actions_service_1 = require("./actions.service");
var ActionItemDirective = (function () {
    function ActionItemDirective(_el, _renderer, _actionsService) {
        this._el = _el;
        this._renderer = _renderer;
        this._actionsService = _actionsService;
    }
    ActionItemDirective.prototype.ngAfterViewInit = function () {
        this._createAnchor(this._el.nativeElement, this.actionItem);
    };
    ActionItemDirective.prototype.onActionClicked = function ($event, menuItem) {
        $event.preventDefault();
        var item = menuItem ? menuItem : this.actionItem;
        if (!item.children) {
            this._actionsService.announceAction(item);
        }
    };
    ActionItemDirective.prototype._createAnchor = function (ele, menuItem, submenu) {
        var _this = this;
        if (submenu === void 0) { submenu = false; }
        var anchor = this._renderer.createElement(ele, 'a');
        this._renderer.setElementAttribute(anchor, 'href', '');
        if (submenu) {
            this._renderer.listen(anchor, 'click', function (event) {
                _this.onActionClicked(event, menuItem);
            });
        }
        var icon = menuItem.icon;
        if (icon) {
            var i = this._renderer.createElement(anchor, 'i');
            this._renderer.setElementClass(i, 'zmdi', true);
            this._renderer.setElementClass(i, "zmdi-" + icon, true);
            if (this._actionsService.showBig) {
                this._renderer.setElementClass(i, 'tm-icon', true);
            }
        }
        var title = menuItem.title;
        if (title) {
            this._renderer.createText(anchor, title);
        }
        if (menuItem.children) {
            this._renderer.setElementClass(ele, 'dropdown', true);
            this._renderer.setElementAttribute(ele, 'data-toggle', 'dropdown');
            var ul_1 = this._renderer.createElement(ele, 'ul');
            this._renderer.setElementClass(ul_1, 'dropdown-menu', true);
            this._renderer.setElementClass(ul_1, 'dm-icon', true);
            this._renderer.setElementClass(ul_1, 'dropdown-menu-right', true);
            this.actionItem.children.forEach(function (item) {
                var li = _this._renderer.createElement(ul_1, 'li');
                _this._createAnchor(li, item, true);
            });
        }
    };
    return ActionItemDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", menu_item_1.MenuItem)
], ActionItemDirective.prototype, "actionItem", void 0);
__decorate([
    core_1.HostListener('click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent, menu_item_1.MenuItem]),
    __metadata("design:returntype", void 0)
], ActionItemDirective.prototype, "onActionClicked", null);
ActionItemDirective = __decorate([
    core_1.Directive({ selector: '[actionItem]' }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, actions_service_1.ActionsService])
], ActionItemDirective);
exports.ActionItemDirective = ActionItemDirective;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/actions/action-item.directive.js
// module id = 73
// module chunks = 0